import { render, staticRenderFns } from "./PdfFlipBook.vue?vue&type=template&id=51f96986&"
import script from "./PdfFlipBook.vue?vue&type=script&lang=js&"
export * from "./PdfFlipBook.vue?vue&type=script&lang=js&"
import style0 from "./PdfFlipBook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports